import React from 'react';
import { StepIntro, TextAreaField, TextField, YesNo } from '../fields';

export function StepAreas({ data, set }) {
  const f = (k) => (v) => set({ ...data, [k]: v });
  return (
    <div className="space-y-4">
      <StepIntro title="Areas you cover" text="Helps customers (and Google) know where you work." />
      <TextAreaField id="towns" label="Towns, cities and counties covered" value={data.towns} onChange={f('towns')} rows={3} placeholder="e.g. Manchester, Stockport, Cheshire, Altrincham and surrounding areas" />
      <TextField id="postcodes" label="Postcode areas" value={data.postcodes} onChange={f('postcodes')} optional placeholder="e.g. M, SK, WA" />
      <TextField id="radius" label="Travel radius" value={data.radius} onChange={f('radius')} placeholder="e.g. approximately 30 miles" />
    </div>
  );
}

export function StepAbout({ data, set }) {
  const f = (k) => (v) => set({ ...data, [k]: v });
  return (
    <div className="space-y-4">
      <StepIntro title="About your business" text="We turn this into the words on your website — be as detailed as you like." />
      <TextAreaField id="about" label="About the business" value={data.about} onChange={f('about')} rows={5} placeholder="How you started, what you specialise in, who you work for…" />
      <TextField id="years" label="Years of experience" value={data.years} onChange={f('years')} inputMode="numeric" placeholder="e.g. 12" />
      <TextAreaField id="why_choose" label="Why should customers choose you?" value={data.why_choose} onChange={f('why_choose')} rows={3} />
      <div className="grid sm:grid-cols-2 gap-4">
        <YesNo id="free_quotes" label="Free quotations?" value={data.free_quotes} onChange={f('free_quotes')} />
        <YesNo id="insured" label="Fully insured?" value={data.insured} onChange={f('insured')} />
      </div>
      <TextAreaField id="guarantees" label="Guarantees offered" value={data.guarantees} onChange={f('guarantees')} optional rows={2} placeholder="e.g. 10-year installation guarantee" />
      <TextAreaField id="qualifications" label="Qualifications & accreditations" value={data.qualifications} onChange={f('qualifications')} optional rows={2} placeholder="e.g. Ox Resin trained & approved installer" />
      <TextAreaField id="other_points" label="Other selling points" value={data.other_points} onChange={f('other_points')} optional rows={2} />
    </div>
  );
}

export function StepSocial({ data, set }) {
  const f = (k) => (v) => set({ ...data, [k]: v });
  return (
    <div className="space-y-4">
      <StepIntro title="Social media" text="We'll link these from your website. Leave blank any you don't use." />
      {['facebook', 'instagram', 'tiktok', 'linkedin', 'youtube'].map((k) => (
        <TextField key={k} id={k} label={k === 'tiktok' ? 'TikTok' : k === 'linkedin' ? 'LinkedIn' : k === 'youtube' ? 'YouTube' : k[0].toUpperCase() + k.slice(1)} value={data[k]} onChange={f(k)} optional placeholder={`https://${k}.com/…`} inputMode="url" />
      ))}
    </div>
  );
}

export function StepEnquiries({ data, set }) {
  const f = (k) => (v) => set({ ...data, [k]: v });
  const ch = data.channels || {};
  const toggle = (k) => set({ ...data, channels: { ...ch, [k]: !ch[k] } });
  return (
    <div className="space-y-4">
      <StepIntro title="Website enquiries" text="Where should new leads from your website go?" />
      <TextField id="enq_email" label="Email address for enquiries" value={data.email} onChange={f('email')} type="email" inputMode="email" />
      <TextField id="enq_mobile" label="Mobile number for enquiries" value={data.mobile} onChange={f('mobile')} type="tel" inputMode="tel" />
      <div>
        <p className="text-sm font-semibold text-slate-800 mb-2">How would you like to be notified?</p>
        <div className="flex gap-2">
          {[['email', 'Email'], ['sms', 'SMS'], ['whatsapp', 'WhatsApp']].map(([k, l]) => (
            <button key={k} type="button" onClick={() => toggle(k)} aria-pressed={!!ch[k]} data-testid={`ww-enq-${k}`} className={`flex-1 h-11 rounded-lg border text-sm font-semibold ${ch[k] ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-700 border-slate-300'}`}>{l}</button>
          ))}
        </div>
        <p className="text-xs text-slate-500 mt-2">Enquiries can be fed straight into your ProPortal leads later on.</p>
      </div>
    </div>
  );
}

export function StepExtra({ data, set }) {
  const f = (k) => (v) => set({ ...data, [k]: v });
  return (
    <div className="space-y-4">
      <StepIntro title="Anything else?" text="Last bits before you review your order." />
      <TextAreaField id="notes" label="Is there anything else you'd like us to know about your website?" value={data.notes} onChange={f('notes')} optional rows={5} />
      <TextAreaField id="liked_sites" label="Links to websites you like" value={data.liked_sites} onChange={f('liked_sites')} optional rows={3} placeholder="One link per line — tell us what you like about each" />
    </div>
  );
}
